import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTitle } from 'react-use';
import { useHistory, useLocation } from 'react-router';

import { coreHideNotices } from 'CorePackage/MainModule/actions/coreActions';
import { Layout } from 'CorePackage/MainModule/components/Layout';
import { ROUTE_PORTAL } from 'CorePackage/MainModule/constants/routes';

import styles from './PublickExtractPage.module.scss';
import { getExtractDisclaimer } from '../services/requests';

export const PublickExtractPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');
  const decision = searchParams.get('decision');
  const aGuid = searchParams.get('a_guid');
  const pGuid = searchParams.get('p_guid');
  const v = searchParams.get('v');
  const [disclaimer, setDisclaimer] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('Ссылка не действиетельна');
  const [errorRequest, setErrorRequest] = useState(false);
  const history = useHistory();

  const isAllRequiredQueryParams = useMemo(() => {
    return !!id && !!decision && !!v;
  }, [id, decision, v]);

  useEffect(() => {
    if (isAllRequiredQueryParams) {
      getExtractDisclaimer(id, decision, aGuid, pGuid, v)
        .then(discl => {
          setDisclaimer(discl);
        })
        .catch(() => {
          setErrorMessage('Произошла ошибка при загрузке выписки. Пожалуйста, попробуйте позже.');
          setErrorRequest(true);
        })
        .finally(() => setIsLoading(false));
    }
  }, [isAllRequiredQueryParams, id, decision, aGuid, pGuid, v]);

  useTitle('Выписка');

  useEffect(() => {
    window.scroll(0, 0);
    return () => {
      dispatch(coreHideNotices());
    };
  }, [dispatch]);

  useEffect(() => {
    if (disclaimer === 'KNM_NOT_VALID_BY_STATUS' || disclaimer === 'PM_NOT_VALID_BY_STATUS') {
      history.push(`${ROUTE_PORTAL}?mt=${disclaimer === 'KNM_NOT_VALID_BY_STATUS' ? 'knm' : 'pm'}`);
    }
    if (disclaimer.indexOf('KNMVALID_') > -1 || disclaimer.indexOf('PMVALID_') > -1) {
      const accessToken = disclaimer.split('_')[1];

      history.push(`${ROUTE_PORTAL}/public-knm/link-only/${accessToken}`);
    }
  }, [disclaimer, history]);

  if (isLoading) return null;

  return (
    <Layout>
      <div className={styles.Wrapper}>
        {!isAllRequiredQueryParams || errorRequest ? (
          <div>{errorMessage}</div>
        ) : (
          <>
            <div dangerouslySetInnerHTML={{ __html: disclaimer }} />
            <div>Для ознакомления с дополнительной информацией рекомендуем перейти в</div>
            <div>
              Личный кабинет портала &quot;Госуслуги&quot; в раздел{' '}
              <a href="https://lk.gosuslugi.ru/org-profile/knd" target="_blank" rel="noreferrer">
                &quot;Контроль (надзор)&quot;
              </a>
            </div>
          </>
        )}
      </div>
    </Layout>
  );
};
